import React, { CSSProperties } from "react";
import { colors } from "../../styles/variables";

export const MinusIconSvg = ({
  color,
  width = "10",
  height = "10",
  ariaLabel = "minus",
}: {
  color?: CSSProperties["color"];
  height?: string;
  width?: string;
  ariaLabel?: string;
}) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 9.44772 0.447715 9 1 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H1C0.447715 11 0 10.5523 0 10Z"
      fill={color || colors.gray900}
    />
  </svg>
);
